import { configureStore } from '@reduxjs/toolkit'
import reducer from 'redux-store/redux/index'

const store = configureStore({
  reducer
})

export default store
